import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Quote } from "src/app/models/Quote.model";
import { RootStoreState } from "src/app/root-store";
import { getCurrentUser } from "src/app/root-store/main-app-store/selectors/auth.selector";
import { KwikspaceService } from "src/app/services/kwikspace.service";
import { StaticDataService } from "src/app/services/static-data.service";
import { AppRoutes } from "src/app/shared/endpoints.enum";

@Component({
  selector: "app-view-purchase",
  templateUrl: "./view-purchase.component.html",
  styleUrls: ["./view-purchase.component.scss"],
})
export class ViewPurchaseComponent implements OnInit {
  private ngUnsubscribe = new Subject();
  private cancelationSubscription = new Subscription();

  @Input() data: Quote;
  quote: Quote;

  isStaff: boolean = false;

  downloadPurchaseQuoteLoading: boolean = false;
  downloadPurchaseQuoteDrawLoading: boolean = false;

  initSubTotal = 0;
  initVat = 0;
  initTotal = 0;

  constructor(
    private store: Store<RootStoreState.RootState>,
    private service: KwikspaceService,
    private staticDataService: StaticDataService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.store
      .select(getCurrentUser)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.isStaff =
            res.isStaff && res.salesRep != null && res.customer == null
              ? true
              : false;
        }
      });
    if (this.data) {
      this.populatePricing();
    }
  }

  populatePricing() {
    // debugger
    let _data = this.data;

    if (_data.purchaseLineItems && _data.purchaseLineItems.length > 0) {

      _data.purchaseLineItems.forEach((item) => {
        item.quantity = item.quantity == 0 ? 1 : item.quantity;
        item.deliveryChargeQty = item.quantity == 0 ? 1 : item.quantity;

        if (item.totalPrice && item.deliveryCharge) {
          let itemTotal = parseFloat(item.totalPrice) + parseFloat(item.deliveryCharge.price);
          this.initSubTotal += itemTotal;
        } else {
          this.initSubTotal = parseFloat(item.totalPrice);
        }
        if (item.deliveryCharge) {
          item.deliveryCharge.totalDeliveryPrice = item.deliveryChargeQty * item.deliveryCharge.price;
        }
      });

      this.initTotal = this.initSubTotal * 1.15;
      this.initVat = this.initTotal - this.initSubTotal;
    }

    this.quote = _data;
    this.requiredTextAlter();
  }

  requiredTextAlter() {
    const requiredBy = this.staticDataService.getRequiredBy();
    let _requiredBy = this.quote.requiredBy;

    const _id = requiredBy.findIndex(
      (obj) => obj.id == _requiredBy
    );

    this.quote.requiredBy = requiredBy[_id].name;
  }

  back() {
    const route = AppRoutes.PWA + AppRoutes.QUOTE_LIST;
    this.router.navigate([route]);
  }

  download() {
    this.downloadPurchaseQuoteLoading = true;
    this.service.downloadPurchaseQuote(this.data.id).subscribe((response) => {
      const contentType = "application/pdf";
      const blob = new Blob([response], { type: contentType });
      const downloadUrl = URL.createObjectURL(blob);

      const pdfName = `${this.data.quoteNumber}_${this.data.customer.company.name}.pdf`;
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = pdfName;

      a.click();
      setTimeout(() => {
        this.downloadPurchaseQuoteLoading = false;
        URL.revokeObjectURL(downloadUrl);
      }, 100);
    });
  }

  downloadDrawings() {
    this.quote.purchaseLineItems.forEach((item) => {
      if (item.thumbnailThreeD) {
        window.open(item.thumbnailThreeD, '_blank');
      }
    });
  }

  view3d(item) {
    if (item.thumbnailThreeD) {
      window.open(item.thumbnailThreeD, '_blank');
    };
  }
  
  view2d(item) {
    if (item.thumbnail) {
      window.open(item.thumbnail, '_blank');
    };
  }

  viewDrawing(drawing: string) {
    if (!drawing) return;
    const url = `assets/purchase-drawings/${drawing}.pdf`;
    window.open(url, '_blank');
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.cancelationSubscription.unsubscribe();
  }
}
